export default import.meta.ROLLDOWN_FILE_URL_sbAWO0gSrg5u$C2LWBrwOA